<template>
  <div class="cc-page">
    <div class="cc-main">
    <div class="cc-shell">
      <!-- Cabeçalho -->
      <div class="cc-head">
        <div class="cc-head__brand">
          <img src="../../assets/logoTemplus.png" alt="Templus" />
          <div>
            <div class="cc-head__title">Criar conta</div>
            <p class="cc-head__sub">Cadastre sua igreja e comece a usar em minutos.</p>
          </div>
        </div>
        <span class="cc-head__pill"><v-icon x-small left color="#00695C">mdi-check-decagram</v-icon>Passo {{ step }} de {{ totalSteps }}</span>
      </div>

      <!-- Stepper -->
      <div class="cc-stepper">
        <div class="cc-steps">
          <div
            v-for="(s, i) in steps" :key="s.key"
            class="cc-step" :class="{ 'cc-step--on': step === i + 1, 'cc-step--done': step > i + 1 }"
          >
            <span class="cc-step__ic"><v-icon small>{{ step > i + 1 ? 'mdi-check' : s.icon }}</v-icon></span>
            <span class="cc-step__label">{{ s.label }}</span>
          </div>
        </div>
        <div class="cc-progress"><div class="cc-progress__fill" :style="{ width: (step / totalSteps * 100) + '%' }"></div></div>
      </div>

      <!-- Conteúdo do passo -->
      <div class="cc-panel">
        <v-form ref="form" @submit.prevent="onSubmit">
          <!-- PASSO 1: Plano -->
          <div v-show="step === 1">
            <div class="cc-planos">
              <button
                type="button"
                v-for="p in planos" :key="p.id"
                class="cc-plano"
                :class="{ 'cc-plano--sel': planoId === p.id, 'cc-plano--pop': p.popular }"
                @click="planoId = p.id"
              >
                <span v-if="p.popular" class="cc-plano-badge">POPULAR</span>
                <v-icon class="cc-plano-check" small :color="planoId === p.id ? '#00695C' : '#cfd9d5'">
                  {{ planoId === p.id ? 'mdi-check-circle' : 'mdi-checkbox-blank-circle-outline' }}
                </v-icon>
                <span class="cc-plano-faixa">{{ p.faixa }}</span>
                <span class="cc-plano-sub">{{ p.subtitulo }}</span>
                <div class="cc-plano-valor">
                  <span class="cc-plano-num">{{ moeda(p.valor) }}</span>
                  <span class="cc-plano-sufixo">{{ p.sufixo }}</span>
                </div>
              </button>
            </div>
          </div>

          <!-- PASSO 2: Igreja -->
          <div v-show="step === 2">
            <v-row dense>
              <v-col cols="12" sm="6" class="py-1">
                <v-text-field v-model="igreja.nome" label="Nome da igreja*" outlined dense color="#00695C" hide-details="auto" :rules="[obrigatorio]" prepend-inner-icon="mdi-church"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="py-1">
                <v-text-field v-model="igreja.cnpj" label="CNPJ (opcional)" outlined dense color="#00695C" hide-details="auto" v-mask="'##.###.###/####-##'" type="tel" prepend-inner-icon="mdi-card-account-details-outline"></v-text-field>
              </v-col>
              <v-col cols="12" class="py-1">
                <v-text-field v-model="igreja.endereco" label="Endereço (opcional)" outlined dense color="#00695C" hide-details="auto" prepend-inner-icon="mdi-map-marker-outline"></v-text-field>
              </v-col>
            </v-row>

            <p class="cc-section mt-4">Logo <span class="cc-opcional">(opcional)</span></p>
            <div class="cc-logo-row">
              <div class="cc-logo-preview">
                <img v-if="igreja.logoUrl && !logoErro" :src="igreja.logoUrl" alt="logo" @error="logoErro = true" />
                <v-icon v-else color="#b9c6c1">mdi-image-outline</v-icon>
              </div>
              <v-text-field v-model="igreja.logoUrl" label="URL do logo (link de uma imagem)" outlined dense color="#00695C" hide-details="auto" prepend-inner-icon="mdi-image-outline" @input="logoErro = false"></v-text-field>
            </div>
            <div class="cc-logo-actions">
              <v-btn small text color="#00695C" @click="dialogLogo = true"><v-icon left small>mdi-upload</v-icon>Enviar imagem</v-btn>
              <v-btn v-if="igreja.logoUrl" small text color="error" @click="igreja.logoUrl = ''; logoErro = false"><v-icon left small>mdi-close</v-icon>Remover</v-btn>
              <span class="cc-logo-hint">Cole um link acima ou envie uma imagem do seu dispositivo.</span>
            </div>

            <p class="cc-section mt-4">Contato <span class="cc-opcional">(opcional)</span></p>
            <v-row dense>
              <v-col cols="12" class="py-1">
                <v-text-field v-model="igreja.telefone" label="Telefone" outlined dense color="#00695C" hide-details="auto" v-mask="'(##) #####-####'" type="tel" prepend-inner-icon="mdi-phone-outline"></v-text-field>
              </v-col>
            </v-row>
          </div>

          <!-- PASSO 3: Administrador -->
          <div v-show="step === 3">
            <v-row dense>
              <v-col cols="12" sm="6" class="py-1">
                <v-text-field v-model="usuario.nome" label="Seu nome*" outlined dense color="#00695C" hide-details="auto" :rules="[obrigatorio]" prepend-inner-icon="mdi-account-outline"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="py-1">
                <v-text-field v-model="usuario.email" label="E-mail*" outlined dense color="#00695C" hide-details="auto" :rules="emailRules" type="email" prepend-inner-icon="mdi-email-outline"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="py-1">
                <v-text-field v-model="usuario.telefone" label="WhatsApp (opcional)" outlined dense color="#00695C" hide-details="auto" v-mask="'(##) #####-####'" type="tel" prepend-inner-icon="mdi-whatsapp"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="py-1">
                <v-text-field
                  v-model="usuario.password"
                  label="Senha* (mín. 6 caracteres)"
                  outlined dense color="#00695C" hide-details="auto"
                  :rules="senhaRules"
                  :type="mostrarSenha ? 'text' : 'password'"
                  prepend-inner-icon="mdi-lock-outline"
                  :append-icon="mostrarSenha ? 'visibility' : 'visibility_off'"
                  @click:append="mostrarSenha = !mostrarSenha"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="py-1">
                <div class="cc-captcha">
                  <p class="cc-captcha-label"><v-icon small color="#00695C">mdi-shield-check</v-icon> Verificação anti-spam</p>
                  <div class="cc-captcha-row">
                    <div class="cc-captcha-q">{{ captchaPergunta || '...' }}</div>
                    <v-text-field
                      v-model="captchaResposta"
                      type="tel" outlined dense hide-details color="#00695C"
                      class="cc-captcha-input" placeholder="?"
                    ></v-text-field>
                    <v-btn icon class="cc-captcha-refresh" :loading="carregandoCaptcha" @click="carregarCaptcha" title="Gerar outra continha">
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>

          <!-- PASSO 4: Pagamento -->
          <div v-show="step === 4">
            <div class="cc-pay__info">
              <v-icon left small color="#1E7A5E">mdi-cash-multiple</v-icon>
              <span>Ative sua assinatura mensal. A cobrança é feita automaticamente via <strong>PIX</strong>.</span>
            </div>

            <p class="cc-section">Plano</p>
            <div class="cc-pay__plano" v-if="planoSel">
              <span class="cc-plano-faixa">{{ planoSel.faixa }}</span>
              <span><span class="cc-plano-num">{{ moeda(planoSel.valor) }}</span> <span class="cc-plano-sufixo">/mês</span></span>
            </div>

            <p class="cc-section mt-3">Dados de cobrança</p>
            <v-row dense class="mb-1">
              <v-col cols="12" sm="4" class="py-1">
                <v-select v-model="cobranca.tipoDocumento" :items="['CPF', 'CNPJ']" label="Tipo*" outlined dense color="#00695C" hide-details="auto" @change="cobranca.cpfCnpj = ''"></v-select>
              </v-col>
              <v-col cols="12" sm="8" class="py-1">
                <v-text-field v-model="cobranca.cpfCnpj" :label="cobranca.tipoDocumento + ' do responsável*'" outlined dense color="#00695C" hide-details="auto" type="tel" v-mask="cobranca.tipoDocumento === 'CNPJ' ? '##.###.###/####-##' : '###.###.###-##'"></v-text-field>
              </v-col>
            </v-row>
            <v-select
              v-model="cobranca.diaVencimento"
              :items="diasVencimento"
              label="Dia de vencimento das cobranças*"
              hint="Escolha entre os dias 5, 10, 15, 20, 25 ou 30."
              persistent-hint
              outlined dense color="#00695C"
              prepend-inner-icon="mdi-calendar-clock"
              class="mb-3"
            ></v-select>

            <p class="cc-section mt-3">Endereço de cobrança <span class="cc-opcional">(para a nota fiscal)</span></p>
            <v-row dense>
              <v-col cols="12" sm="4" class="py-1">
                <v-text-field v-model="cobranca.endereco.cep" label="CEP*" outlined dense color="#00695C" hide-details="auto" type="tel" v-mask="'#####-###'" :loading="buscandoCep" @blur="buscarCep"></v-text-field>
              </v-col>
              <v-col cols="12" sm="8" class="py-1">
                <v-text-field v-model="cobranca.endereco.logradouro" label="Logradouro*" outlined dense color="#00695C" hide-details="auto"></v-text-field>
              </v-col>
              <v-col cols="6" sm="4" class="py-1">
                <v-text-field v-model="cobranca.endereco.numero" label="Número*" outlined dense color="#00695C" hide-details="auto" type="tel"></v-text-field>
              </v-col>
              <v-col cols="6" sm="8" class="py-1">
                <v-text-field v-model="cobranca.endereco.bairro" label="Bairro" outlined dense color="#00695C" hide-details="auto"></v-text-field>
              </v-col>
              <v-col cols="8" class="py-1">
                <v-text-field v-model="cobranca.endereco.municipio" label="Cidade*" outlined dense color="#00695C" hide-details="auto"></v-text-field>
              </v-col>
              <v-col cols="4" class="py-1">
                <v-text-field v-model="cobranca.endereco.estado" label="UF*" outlined dense color="#00695C" hide-details="auto" maxlength="2"></v-text-field>
              </v-col>
            </v-row>

            <p class="cc-pay-hint"><v-icon x-small color="#97a3a0">mdi-lock-outline</v-icon> A 1ª cobrança será gerada na próxima data escolhida. Seu acesso é liberado assim que a conta é criada.</p>
          </div>

          <!-- Navegação -->
          <div class="cc-nav">
            <v-btn v-if="step > 1" text class="cc-nav__back" :disabled="enviando || ativandoAssinatura" @click="voltar">
              <v-icon left>mdi-arrow-left</v-icon>Voltar
            </v-btn>
            <router-link v-else to="/" class="cc-nav__site"><v-icon small>mdi-arrow-left</v-icon> Voltar ao site</router-link>
            <v-spacer></v-spacer>
            <v-btn v-if="step < totalSteps" depressed color="#00695C" dark class="cc-nav__next" @click="proximo">
              Próximo<v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
            <v-btn v-else depressed color="#00695C" dark class="cc-nav__next" :loading="enviando || ativandoAssinatura" @click="finalizar">
              <v-icon left>mdi-rocket-launch</v-icon>Criar conta
            </v-btn>
          </div>
        </v-form>
      </div>

      <p class="cc-foot">Já tem conta? <router-link to="/login" class="cc-link">Entrar</router-link></p>
    </div>
    </div>

    <footer class="cc-footer">
      <div class="cc-footer__inner">
        <div class="cc-footer__brand">
          <div class="cc-footer__logos">
            <img src="../../assets/logoTemplusBranca.png" alt="Templus" />
            <img src="../../assets/LogoBrancoHorizontal.png" alt="Intelite Tecnologia" class="cc-footer__logos-int" />
          </div>
          <h4 class="cc-footer__bt">Intelite Tecnologia</h4>
          <p class="cc-footer__desc">
            A Intelite Tecnologia é uma empresa de desenvolvimento de software que atua em âmbito nacional
            com um time dinâmico, processos ágeis, inovação e aperfeiçoamento contínuo. Buscamos fornecer
            vantagens competitivas para os nossos clientes com qualidade, segurança e inteligência.
          </p>
          <div class="cc-footer__social">
            <a href="https://www.instagram.com/intelite_tecnologia/" target="_blank" rel="noopener" aria-label="Instagram"><v-icon small>mdi-instagram</v-icon></a>
            <a href="https://api.whatsapp.com/send/?phone=558335125222" target="_blank" rel="noopener" aria-label="WhatsApp"><v-icon small>mdi-whatsapp</v-icon></a>
            <a href="https://www.intelitetecnologia.com.br/" target="_blank" rel="noopener" aria-label="Site"><v-icon small>mdi-web</v-icon></a>
          </div>
        </div>

        <div class="cc-footer__col">
          <h4>Produto</h4>
          <router-link to="/">Recursos</router-link>
          <router-link to="/">Planos</router-link>
          <router-link to="/login">Entrar</router-link>
          <router-link to="/criar-conta">Criar conta</router-link>
        </div>

        <div class="cc-footer__col cc-footer__col--contato">
          <h4>Contato</h4>
          <div class="cc-footer__ci">
            <v-icon small>mdi-map-marker-outline</v-icon>
            <span>R. Carteiro Olivio Pontes, 575<br />Água Fria, João Pessoa - PB<br />58053-020</span>
          </div>
          <div class="cc-footer__ci">
            <v-icon small>mdi-phone-outline</v-icon>
            <span>(83) 3512-5222</span>
          </div>
          <a class="cc-footer__ci" href="https://www.intelitetecnologia.com.br/" target="_blank" rel="noopener">
            <v-icon small>mdi-web</v-icon>
            <span>intelitetecnologia.com.br</span>
          </a>
        </div>

        <div class="cc-footer__col">
          <h4>Legal</h4>
          <a href="https://www.intelitetecnologia.com.br/" target="_blank" rel="noopener">Privacidade</a>
          <a href="https://www.intelitetecnologia.com.br/" target="_blank" rel="noopener">Termos de uso</a>
          <a href="https://www.intelitetecnologia.com.br/" target="_blank" rel="noopener">LGPD</a>
        </div>
      </div>

      <div class="cc-footer__bottom">
        <span>© {{ ano }} Templus · Todos os direitos reservados</span>
        <div class="cc-footer__intelite"><span>Uma solução</span><img src="../../assets/LogoBrancoHorizontal.png" alt="Intelite Tecnologia" /></div>
      </div>
    </footer>

    <!-- Upload/recorte do logo -->
    <v-dialog v-model="dialogLogo" max-width="560px" persistent>
      <v-card class="cc-card-base" style="padding: 8px;">
        <v-card-title><span class="tp-serif" style="font-weight:600;color:#16322E">Enviar logo</span></v-card-title>
        <v-card-text>
          <vueAnkaCropper
            :options="{
              aspectRatio: false,
              closeOnSave: true,
              cropArea: 'box',
              croppedWidth: 512,
              croppedHeight: false,
              cropperHeight: false,
              dropareaMessage: 'Arraste uma imagem aqui ou escolha do dispositivo',
              maxFileSize: 4000000,
              resultQuality: 0.9,
              resultMimeType: 'image/png',
              selectButtonLabel: 'Escolher imagem',
              showPreview: true,
              skin: 'light',
              uploadData: {},
              uploadTo: false
            }"
            @cropper-error="erroLogo($event)"
            @cropper-saved="salvarLogo($event)"
            @cropper-cancelled="dialogLogo = false"
          ></vueAnkaCropper>
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer></v-spacer>
          <v-btn text color="#5b6b67" @click="dialogLogo = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Snackbar ref="chamaSnackbar" />
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl } from '@/global'
import { PLANOS, formatBRL, planoPorId } from '@/plans'
import Snackbar from '../../componentes/snackbar.vue'
import vueAnkaCropper from 'vue-anka-cropper'

export default {
  name: 'CriarConta',
  components: { Snackbar, vueAnkaCropper },
  data() {
    return {
      step: 1,
      totalSteps: 4,
      ano: new Date().getFullYear(),
      steps: [
        { key: 'plano', label: 'Plano', icon: 'mdi-tag-outline' },
        { key: 'igreja', label: 'Igreja', icon: 'mdi-church' },
        { key: 'admin', label: 'Administrador', icon: 'mdi-account-tie-outline' },
        { key: 'pagamento', label: 'Pagamento', icon: 'mdi-credit-card-outline' },
      ],
      enviando: false,
      mostrarSenha: false,
      captchaToken: '',
      captchaPergunta: '',
      captchaResposta: '',
      carregandoCaptcha: false,
      planos: PLANOS,
      planoId: '',
      igreja: { nome: '', cnpj: '', endereco: '', logoUrl: '', telefone: '' },
      logoErro: false,
      dialogLogo: false,
      usuario: { nome: '', email: '', telefone: '', password: '' },
      // Cobrança (passo 4 do wizard)
      tempToken: '',
      contaCriada: false,
      ativandoAssinatura: false,
      buscandoCep: false,
      diasVencimento: [5, 10, 15, 20, 25, 30],
      cobranca: {
        tipoDocumento: 'CPF',
        cpfCnpj: '',
        diaVencimento: null,
        endereco: { cep: '', logradouro: '', numero: '', bairro: '', municipio: '', estado: '' },
      },
      obrigatorio: v => !!v || 'Campo obrigatório',
      emailRules: [
        v => !!v || 'E-mail é obrigatório',
        v => /.+@.+\..+/.test(v) || 'E-mail inválido',
      ],
      senhaRules: [
        v => !!v || 'Senha é obrigatória',
        v => (v && v.length >= 6) || 'Mínimo de 6 caracteres',
      ],
    }
  },
  computed: {
    planoSel() { return planoPorId(this.planoId) },
  },
  mounted() {
    // Segue o tema escolhido na landing (claro/escuro)
    this.$vuetify.theme.dark = localStorage.getItem('tp-landing-theme') === 'dark'
    const q = this.$route.query.plano
    if (q && planoPorId(q)) {
      this.planoId = q
    } else {
      const popular = this.planos.find(p => p.popular)
      this.planoId = popular ? popular.id : (this.planos[0] && this.planos[0].id) || ''
    }
    this.carregarCaptcha()
  },
  methods: {
    moeda(v) { return formatBRL(v) },
    // Recorte concluído: grava a imagem (base64) direto no logoUrl.
    salvarLogo(event) {
      this.igreja.logoUrl = event.croppedImageURI
      this.logoErro = false
      this.dialogLogo = false
    },
    erroLogo(event) {
      const e = String(event || '')
      if (e.substring(0, 5) === 'Wrong') {
        this.$refs.chamaSnackbar.snack('#F9A825', 'Apenas imagens são permitidas.', 'ATENÇÃO')
      } else if (e.substring(0, 4) === 'File') {
        this.$refs.chamaSnackbar.snack('#F9A825', 'Imagem muito grande. Máximo de 4MB.', 'ATENÇÃO')
      } else {
        this.$refs.chamaSnackbar.snack('#EF5350', 'Não foi possível carregar a imagem.', 'ERRO')
      }
    },
    onSubmit() {
      if (this.step < this.totalSteps) this.proximo()
      else this.finalizar()
    },
    proximo() {
      if (this.step === 1 && (!this.planoId || !planoPorId(this.planoId))) {
        this.$refs.chamaSnackbar.snack('#F9A825', 'Selecione um plano.', 'ATENÇÃO')
        return
      }
      if (this.step === 2 && !this.igreja.nome) {
        this.$refs.chamaSnackbar.snack('#F9A825', 'Informe o nome da igreja.', 'ATENÇÃO')
        return
      }
      if (this.step === 3 && !this.validarAdmin()) return
      if (this.step < this.totalSteps) this.step++
    },
    validarAdmin() {
      if (!this.usuario.nome) {
        this.$refs.chamaSnackbar.snack('#F9A825', 'Informe seu nome.', 'ATENÇÃO'); return false
      }
      if (!/.+@.+\..+/.test(this.usuario.email || '')) {
        this.$refs.chamaSnackbar.snack('#F9A825', 'Informe um e-mail válido.', 'ATENÇÃO'); return false
      }
      if (!this.usuario.password || this.usuario.password.length < 6) {
        this.$refs.chamaSnackbar.snack('#F9A825', 'A senha deve ter no mínimo 6 caracteres.', 'ATENÇÃO'); return false
      }
      if (!this.captchaResposta) {
        this.$refs.chamaSnackbar.snack('#F9A825', 'Responda a verificação anti-spam.', 'ATENÇÃO'); return false
      }
      return true
    },
    voltar() {
      if (this.step > 1) this.step--
    },
    async carregarCaptcha() {
      this.carregandoCaptcha = true
      this.captchaResposta = ''
      try {
        const res = await axios.get(baseApiUrl + 'Usuarios/gerarCaptcha')
        this.captchaPergunta = res.data.pergunta
        this.captchaToken = res.data.token
      } catch (e) {
        this.captchaPergunta = ''
        this.captchaToken = ''
      } finally {
        this.carregandoCaptcha = false
      }
    },
    // Cria a conta e obtém um token temporário (só para ativar a assinatura agora;
    // não persiste sessão). Lança em caso de falha para quem chamou tratar.
    async criarConta() {
      const plano = planoPorId(this.planoId)
      await axios.post(baseApiUrl + 'Usuarios/criarContaPublica', {
        igreja: {
          ...this.igreja,
          planoId: this.planoId,
          valorMensalidade: plano.valor !== null ? plano.valor.toFixed(2) : '',
          faixaMembros: plano.faixa,
        },
        usuario: this.usuario,
        captchaToken: this.captchaToken,
        captchaResposta: this.captchaResposta,
      })
      this.contaCriada = true
      try {
        const login = await axios.post(baseApiUrl + 'Usuarios/login', { email: this.usuario.email, password: this.usuario.password })
        this.tempToken = (login.data && login.data.id) || ''
      } catch (e) { this.tempToken = '' }
    },
    mensagemErro(error, fallback) {
      return (error.response && error.response.data && error.response.data.error && error.response.data.error.message)
        ? error.response.data.error.message
        : fallback
    },
    // Criação falhou (ex.: e-mail já usado, captcha errado): volta ao passo do
    // administrador e gera um novo captcha.
    tratarFalhaCriacao(error) {
      this.$refs.chamaSnackbar.snack('#EF5350', this.mensagemErro(error, 'Não foi possível criar a conta. Tente novamente.'), 'ERRO')
      this.carregarCaptcha()
      this.step = 3
    },
    async buscarCep() {
      const cep = (this.cobranca.endereco.cep || '').replace(/\D/g, '')
      if (cep.length !== 8) return
      this.buscandoCep = true
      try {
        const { data } = await axios.get(`https://viacep.com.br/ws/${cep}/json/`)
        if (data && !data.erro) {
          this.cobranca.endereco.logradouro = data.logradouro || this.cobranca.endereco.logradouro
          this.cobranca.endereco.bairro = data.bairro || this.cobranca.endereco.bairro
          this.cobranca.endereco.municipio = data.localidade || this.cobranca.endereco.municipio
          this.cobranca.endereco.estado = data.uf || this.cobranca.endereco.estado
        }
      } catch (e) { /* CEP preenchível manualmente */ } finally {
        this.buscandoCep = false
      }
    },
    // Passo 4 — cria a conta e ativa a assinatura (cobrança obrigatória).
    async finalizar() {
      const doc = (this.cobranca.cpfCnpj || '').replace(/\D/g, '')
      const tam = this.cobranca.tipoDocumento === 'CNPJ' ? 14 : 11
      if (doc.length !== tam) {
        this.$refs.chamaSnackbar.snack('#F9A825', 'Informe um ' + this.cobranca.tipoDocumento + ' válido.', 'ATENÇÃO'); return
      }
      if (!this.cobranca.diaVencimento) {
        this.$refs.chamaSnackbar.snack('#F9A825', 'Selecione o dia de vencimento das cobranças.', 'ATENÇÃO'); return
      }
      const e = this.cobranca.endereco
      if (!e.cep || !e.logradouro || !e.numero || !e.municipio || !e.estado) {
        this.$refs.chamaSnackbar.snack('#F9A825', 'Preencha o endereço de cobrança (necessário para a nota fiscal).', 'ATENÇÃO'); return
      }
      this.enviando = true
      try {
        if (!this.contaCriada) {
          try { await this.criarConta() } catch (error) { this.tratarFalhaCriacao(error); return }
        }
        if (!this.tempToken) {
          this.$refs.chamaSnackbar.snack('#2E9E78', 'Conta criada! Faça login para concluir.', 'SUCESSO')
          setTimeout(() => this.$router.push({ path: '/login' }), 1600)
          return
        }
        this.ativandoAssinatura = true
        await axios.post(`${baseApiUrl}Pagamentos/criarAssinatura?access_token=${this.tempToken}`, {
          planoId: this.planoId,
          nome: this.usuario.nome,
          cpfCnpj: this.cobranca.cpfCnpj,
          email: this.usuario.email,
          telefone: this.usuario.telefone,
          diaVencimento: this.cobranca.diaVencimento,
          endereco: this.cobranca.endereco,
        })
        this.$refs.chamaSnackbar.snack('#2E9E78', 'Conta criada! Faça login para acessar.', 'SUCESSO')
        setTimeout(() => this.$router.push({ path: '/login' }), 1600)
      } catch (error) {
        this.$refs.chamaSnackbar.snack('#EF5350', this.mensagemErro(error, 'Não foi possível concluir o cadastro. Tente novamente.'), 'ERRO')
      } finally {
        this.enviando = false
        this.ativandoAssinatura = false
      }
    },
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,600&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');
@import '../../../node_modules/vue-anka-cropper/dist/VueAnkaCropper.css';

.cc-page { min-height: 100vh; display: flex; flex-direction: column; background: #FBF7F5; font-family: 'Plus Jakarta Sans', sans-serif; }
.cc-main { flex: 1; display: flex; align-items: flex-start; justify-content: center; padding: 40px 20px; }
.cc-shell { width: 100%; max-width: 880px; display: flex; flex-direction: column; gap: 16px; }

/* rodapé */
.cc-footer { background: #00342D; color: rgba(255,255,255,.75); padding: 64px 32px 28px; }
.cc-footer__inner { max-width: 1160px; margin: 0 auto; display: grid; grid-template-columns: 2.2fr 1fr 1.3fr 1fr; gap: 44px; }
.cc-footer__logos { display: flex; align-items: center; gap: 18px; margin-bottom: 22px; }
.cc-footer__logos img { height: 34px; }
.cc-footer__logos-int { height: 30px !important; opacity: .95; }
.cc-footer__bt { color: #fff; font-size: 1.05rem; font-weight: 600; margin: 0 0 12px; }
.cc-footer__desc { font-size: .9rem; line-height: 1.7; margin: 0 0 20px; color: rgba(255,255,255,.7); max-width: 34em; }
.cc-footer__social { display: flex; gap: 12px; }
.cc-footer__social a {
  width: 38px; height: 38px; border-radius: 10px; display: grid; place-items: center;
  background: rgba(255,255,255,.06); border: 1px solid rgba(255,255,255,.12); transition: all .15s ease;
}
.cc-footer__social a .v-icon { color: rgba(255,255,255,.8); }
.cc-footer__social a:hover { background: rgba(91,193,163,.18); border-color: #5BC1A3; }
.cc-footer__social a:hover .v-icon { color: #5BC1A3; }

.cc-footer__col h4 { color: #fff; font-size: 1rem; margin: 0 0 18px; font-weight: 600; }
.cc-footer__col a { display: block; color: rgba(255,255,255,.72); text-decoration: none; font-size: .92rem; margin-bottom: 14px; }
.cc-footer__col a:hover { color: #5BC1A3; }
.cc-footer__ci { display: flex; align-items: flex-start; gap: 10px; color: rgba(255,255,255,.72); font-size: .92rem; margin-bottom: 16px; text-decoration: none; line-height: 1.5; }
.cc-footer__ci .v-icon { color: #5BC1A3; margin-top: 2px; }
a.cc-footer__ci:hover span { color: #5BC1A3; }

.cc-footer__bottom {
  max-width: 1160px; margin: 40px auto 0; padding-top: 24px; border-top: 1px solid rgba(255,255,255,.12);
  display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px;
  font-size: .82rem; color: rgba(255,255,255,.5);
}
.cc-footer__intelite { display: flex; align-items: center; gap: 8px; }
.cc-footer__intelite span { font-size: .82rem; }
.cc-footer__intelite img { height: 24px; }
@media (max-width: 860px) {
  .cc-footer { padding: 48px 22px 24px; }
  .cc-footer__inner { grid-template-columns: 1fr 1fr; gap: 32px; }
  .cc-footer__brand { grid-column: 1 / -1; }
}
@media (max-width: 520px) { .cc-footer__inner { grid-template-columns: 1fr; } }

/* ===== modo escuro ===== */
.theme--dark .cc-page { background: #1a1519; }
.theme--dark .cc-head,
.theme--dark .cc-stepper,
.theme--dark .cc-panel { background: #211a1f; box-shadow: 0 10px 30px rgba(0,0,0,.4); }
.theme--dark .cc-head__title { color: #eaf2ef; }
.theme--dark .cc-head__sub,
.theme--dark .cc-step__label { color: rgba(255,255,255,.65); }
.theme--dark .cc-head__pill { background: rgba(0,105,92,.22); border-color: rgba(91,193,163,.3); color: #7fe3bd; }
.theme--dark .cc-step__ic { background: rgba(255,255,255,.06); }
.theme--dark .cc-step__ic .v-icon { color: rgba(255,255,255,.55); }
.theme--dark .cc-step--on .cc-step__ic { background: #00695C; }
.theme--dark .cc-step--on .cc-step__ic .v-icon { color: #fff; }
.theme--dark .cc-step--on .cc-step__label { color: #5BC1A3; }
.theme--dark .cc-step--done .cc-step__label { color: #eaf2ef; }
.theme--dark .cc-progress { background: rgba(255,255,255,.12); }
.theme--dark .cc-section { color: #5BC1A3; }
.theme--dark .cc-plano { background: rgba(255,255,255,.04); border-color: rgba(255,255,255,.10); }
.theme--dark .cc-plano:hover { border-color: rgba(91,193,163,.4); }
.theme--dark .cc-plano--sel { background: rgba(1,176,148,.12); border-color: #5BC1A3; }
.theme--dark .cc-plano-faixa { color: #eaf2ef; }
.theme--dark .cc-plano-sub,
.theme--dark .cc-plano-sufixo { color: rgba(255,255,255,.6); }
.theme--dark .cc-plano-num { color: #5BC1A3; }
.theme--dark .cc-captcha-q { background: rgba(255,255,255,.06); border-color: rgba(255,255,255,.12); color: #eaf2ef; }
.theme--dark .cc-captcha-refresh { border-color: rgba(255,255,255,.12); }
.theme--dark .cc-foot { color: rgba(255,255,255,.65); }
.theme--dark .cc-nav__back,
.theme--dark .cc-nav__site { color: rgba(255,255,255,.7) !important; }
.theme--dark .cc-pay__info { background: rgba(46,158,120,.15); border-color: rgba(46,158,120,.3); color: #7fe3bd; }
.theme--dark .cc-pay__head { color: #eaf2ef; }

.cc-card-base { background: #fff; border-radius: 16px; box-shadow: 0 10px 30px rgba(0,37,62,.08); }

/* cabeçalho */
.cc-head {
  background: #fff; border-radius: 16px; box-shadow: 0 10px 30px rgba(0,37,62,.08);
  padding: 20px 24px; display: flex; align-items: center; justify-content: space-between; gap: 16px;
}
.cc-head__brand { display: flex; align-items: center; gap: 16px; }
.cc-head__brand img { height: 40px; mix-blend-mode: multiply; }
.cc-head__title { font-family: 'Fraunces', Georgia, serif; font-weight: 600; font-size: 1.5rem; color: #22201E; margin: 0; line-height: 1.1; }
.cc-head__sub { color: #7a726d; font-size: .9rem; margin: 2px 0 0; }
.cc-head__pill {
  display: inline-flex; align-items: center; white-space: nowrap;
  background: rgba(0,105,92,.08); border: 1px solid rgba(0,105,92,.18);
  color: #00695C; font-weight: 600; font-size: .82rem; padding: 7px 13px; border-radius: 999px;
}

/* stepper */
.cc-stepper { background: #fff; border-radius: 16px; box-shadow: 0 10px 30px rgba(0,37,62,.08); padding: 22px 24px 18px; }
.cc-steps { display: flex; justify-content: space-between; gap: 8px; margin-bottom: 16px; }
.cc-step { display: flex; align-items: center; gap: 10px; flex: 1; min-width: 0; }
.cc-step__ic {
  flex: none; width: 40px; height: 40px; border-radius: 11px; display: grid; place-items: center;
  background: #eef3f1; color: #9bb3ab; transition: all .2s ease;
}
.cc-step__ic .v-icon { color: #9bb3ab; }
.cc-step__label { font-weight: 600; font-size: .92rem; color: #9bb3ab; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.cc-step--on .cc-step__ic { background: #00695C; }
.cc-step--on .cc-step__ic .v-icon { color: #fff; }
.cc-step--on .cc-step__label { color: #00695C; }
.cc-step--done .cc-step__ic { background: #E3F3EE; }
.cc-step--done .cc-step__ic .v-icon { color: #1E7A5E; }
.cc-step--done .cc-step__label { color: #22201E; }
.cc-progress { height: 6px; border-radius: 999px; background: #e6efec; overflow: hidden; }
.cc-progress__fill { height: 100%; border-radius: 999px; background: linear-gradient(90deg, #5BC1A3, #00695C); transition: width .3s ease; }

/* painel do passo */
.cc-panel { background: #fff; border-radius: 16px; box-shadow: 0 10px 30px rgba(0,37,62,.08); padding: 26px 26px 22px; }
.cc-panel >>> .v-text-field--outlined .v-input__slot { border-radius: 12px; }

/* planos */
.cc-planos { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; }
.cc-plano {
  position: relative; display: flex; flex-direction: column; align-items: flex-start; gap: 2px; width: 100%;
  text-align: left; cursor: pointer; background: #fff;
  border: 1.5px solid #e6efec; border-radius: 14px; padding: 16px 14px 14px;
  transition: border-color .15s ease, box-shadow .15s ease, background .15s ease;
}
.cc-plano:hover { border-color: #b9ddd2; }
.cc-plano--sel { border-color: #00695C; background: #F3FAF8; box-shadow: 0 6px 18px rgba(0,105,92,.12); }
.cc-plano--pop { border-color: #b9ddd2; }
.cc-plano-badge {
  position: absolute; top: -9px; left: 14px;
  background: linear-gradient(135deg, #5BC1A3, #01B094); color: #fff;
  font-size: .62rem; font-weight: 700; letter-spacing: .08em; padding: 3px 9px; border-radius: 999px;
}
.cc-plano-check { position: absolute; top: 12px; right: 12px; }
.cc-plano-faixa { font-weight: 700; color: #22201E; font-size: .95rem; padding-right: 22px; }
.cc-plano-sub { color: #7a726d; font-size: .78rem; }
.cc-plano-valor { display: flex; align-items: baseline; gap: 4px; margin-top: 8px; }
.cc-plano-num { font-family: 'Fraunces', Georgia, serif; font-weight: 700; font-size: 1.35rem; color: #00695C; line-height: 1.1; }
.cc-plano-sufixo { color: #7a726d; font-size: .7rem; }
.cc-plano-hint { display: flex; align-items: center; gap: 5px; color: #1E7A5E; font-size: .8rem; margin: 12px 0 0; }

/* captcha */
.cc-captcha { margin: 2px 0 0; }
.cc-captcha-label { font-size: .8rem; font-weight: 600; color: #00695C; margin: 0 0 8px; display: flex; align-items: center; gap: 6px; }
.cc-captcha-row { display: flex; align-items: center; gap: 10px; }
.cc-captcha-q {
  flex: 1; max-width: 220px; display: flex; align-items: center; justify-content: center;
  background: #F4F7F6; border: 1px solid #e6efec; border-radius: 10px;
  height: 44px; font-weight: 700; font-size: 1.15rem; color: #22201E; letter-spacing: .04em;
}
.cc-captcha-input { max-width: 88px; }
.cc-captcha-refresh { border: 1px solid #e6efec; border-radius: 10px !important; height: 44px !important; width: 44px !important; }

/* navegação */
.cc-nav { display: flex; align-items: center; margin-top: 22px; }
.cc-nav__back { text-transform: none !important; letter-spacing: 0 !important; color: #7a726d !important; }
.cc-nav__site { color: #7a726d; font-size: .88rem; text-decoration: none; display: inline-flex; align-items: center; gap: 4px; }
.cc-nav__site:hover { color: #00695C; }
.cc-nav__next { border-radius: 999px !important; text-transform: none !important; letter-spacing: 0 !important; font-weight: 600 !important; height: 46px !important; padding: 0 24px !important; }

.cc-foot { text-align: center; margin: 4px 0 0; color: #7a726d; font-size: .9rem; }
.cc-link { color: #00695C; font-weight: 600; text-decoration: none; }
.cc-link:hover { text-decoration: underline; }

/* passo de pagamento */
.cc-section { font-size: .74rem; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; color: #00695C; margin: 6px 0 10px; }
.cc-opcional { font-weight: 500; text-transform: none; letter-spacing: 0; color: #97a3a0; }
.cc-logo-row { display: flex; align-items: center; gap: 12px; }
.cc-logo-preview {
  flex: none; width: 48px; height: 48px; border-radius: 12px; overflow: hidden;
  display: grid; place-items: center; background: #F4F7F6; border: 1px solid #e6efec;
}
.cc-logo-preview img { width: 100%; height: 100%; object-fit: contain; }
.cc-logo-actions { display: flex; align-items: center; flex-wrap: wrap; gap: 4px; margin-top: 6px; }
.cc-logo-hint { color: #97a3a0; font-size: .8rem; margin-left: 4px; }
.cc-pay__info { display: flex; align-items: flex-start; gap: 6px; background: #E9F6F0; border: 1px solid #cfe9df; border-radius: 12px; padding: 12px 14px; color: #1E7A5E; font-size: .9rem; margin: 0 0 18px; }
.cc-pay__plano { display: flex; align-items: baseline; justify-content: space-between; gap: 10px; margin-bottom: 4px; }
.cc-pay-hint { display: flex; align-items: center; gap: 5px; color: #97a3a0; font-size: .8rem; margin: 14px 0 0; }

@media (max-width: 600px) {
  .cc-head { flex-direction: column; align-items: flex-start; }
  .cc-panel { padding: 20px 18px; }
  .cc-planos { grid-template-columns: 1fr; }
  .cc-step__label { display: none; }
  .cc-steps { justify-content: space-around; }
}
</style>
